<template>
  <v-card>
    <v-card-text class="headline text-xs-center secondary--text pb-0">Cadastrando novo Convênio</v-card-text>
    <v-stepper class="elevation-0" v-model="step">
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <v-container fluid grid-list-lg>
            <v-form v-model="valid1" ref="firstForm" lazy-validation>
              <v-layout row wrap>
                <v-tooltip bottom>
                  <v-switch slot="activator" class="ml-4" v-model="tem_desconto_em_reais" :disabled="posto && posto.tipo_desconto !== 2" color="secondary">
                    <template v-slot:label>
                        Tem Desconto em Reais
                    </template>
                  </v-switch>
                  <span>{{ tem_desconto_em_reais ? 'Desativar Desconto Dado em Reais' : 'Ativar Desconto Dado em Reais' }}</span>
                </v-tooltip>
                <v-flex xs12>
                  <v-text-field
                    outline
                    label="Nome do convênio"
                    maxlength="100"
                    counter="100"
                    v-model="dados_convenio.convenio.nome_convenio"
                    required
                    :rules="[
                      v => !!v || 'Insira um nome válido pro convênio'
                    ]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="mb-4">
                  <v-text-field
                    outline
                    label="Desconto em Reais"
                    v-model="dados_convenio.desconto_em_reais"
                    hide-details
                    suffix=""
                    type="text"
                    v-money="money"
                    :disabled="!tem_desconto_em_reais"
                    :rules="tem_desconto_em_reais ? [
                      v => !!v || 'Informe um valor',
                      v => this.formatarValor(v) > -1 || 'Desconto inválido',
                      v => this.formatarValor(v) <= 4.00 || 'Desconto inválido'
                    ] : []"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    outline
                    label="Desconto em percentual"
                    v-model="dados_convenio.desconto"
                    hide-details
                    suffix="%"
                    type="number"
                    id="percentual"
                    :disabled="tem_desconto_em_reais"
                    :rules="!tem_desconto_em_reais ? [
                      () => parseFloat(dados_convenio.desconto) >= 0 || 'Desconto inválido',
                      () => parseFloat(dados_convenio.desconto) <= 100 || 'Desconto inválido'
                    ] : []"
                  />
                </v-flex>
                <v-flex class="mt-4">
                  <v-select
                      outline
                      label="Item"
                      v-model="dados_convenio.item"
                      :items="[{ nome: 'Todos os Itens', id: 0 }, ...todos_itens]"
                      item-text="nome"
                      item-value="id"
                      hide-details
                      single-line
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="dados_convenio.convenio.privado"
                    label="Os códigos são privados"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="2" class="pa-0">
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex
                class="text-xs-center title primary--text"
              >Deseja inserir uma imagem 500x500 ao convênio {{dados_convenio.convenio.nome_convenio}}?</v-flex>
              <v-flex align-self-center>
                <img
                  max-height="250"
                  max-width="250"
                  :src="imagem_convenio ? imagem_convenio : ''"
                  @click="imagem_convenio ? carregarImagem = true : $refs.imageInput.click()"
                  style="cursor: pointer"
                >
                  <v-card v-if="!imagem_convenio" color="grey" height="100%" width="100%">
                    <v-layout justify-center align-center fill-height>
                      <div class="title white--text pa-4 text-xs-center">Sem imagem</div>
                    </v-layout>
                  </v-card>
                <img>
              </v-flex>
              <v-flex class="text-xs-center">
                <v-btn
                  flat
                  block
                  color="grey darken-2"
                  @click="$refs.imageInput.click()"
                  :disabled="cropper"
                >
                  <v-spacer></v-spacer>
                  <template v-if="nome_imagem">{{nome_imagem}}</template>
                  <template v-else>CARREGAR IMAGEM</template>
                  <v-spacer></v-spacer>
                  <v-icon>cloud_upload</v-icon>
                  <input
                    type="file"
                    style="display:none"
                    accept="image/*"
                    ref="imageInput"
                    @input="carregarImagem"
                  />
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-card-actions>
      <v-btn flat color="grey darken-2" @click="voltar()" :disabled="cropper">
        <template v-if="step == 1">CANCELAR</template>
        <template v-else>VOLTAR</template>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn flat color="green" @click="continuar()" :disabled="cropper" :loading="loading">
        <template v-if="step == 2">CONCLUIR</template>
        <template v-else>CONTINUAR</template>
      </v-btn>
      <v-snackbar
        v-model="snackbarerror.active"
        :color="snackbarerror.color"
        :multi-line="snackbarerror.multiLine"
        :timeout="snackbarerror.timeout"
        :vertical="snackbarerror.vertical"
      >
        {{ snackbarerror.errorText }}
        <v-btn
          flat
          @click="snackbarerror.active = false"
        >
          Fechar
        </v-btn>
      </v-snackbar>
    </v-card-actions>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  data () {
    return {
      valid1: false,
      todos_itens: [],
      step: 1,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      id_combustivel: 0,
      imagem_convenio: null,
      nome_imagem: null,
      id_convenio: null,
      dados_convenio: {
        convenio: {
          nome_convenio: null,
          url_imagem_codigo: null,
          privado: false,
          codigo: '',
          notificado: false
        },
        desconto: null,
        qtd_codigos_limitado: false,
        qtd_codigos: null,
        qtd_litros: 0,
        data_solicitacao: null,
        combustivel_ilimitado: true,
        novo: true,
        item: 0,
        desconto_em_reais: null
      },
      croppersrc: null,
      cropper: false,
      convenio_posto: null,
      executado: false,
      tem_desconto_em_reais: false,
      snackbarerror: {
        active: false,
        color: 'error',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        errorText: ''
      }
    }
  },
  watch: {
    tem_desconto_em_reais (val) {
      if (val) {
        this.dados_convenio.desconto_em_reais = '0,00'
        this.dados_convenio.desconto = null
      } else {
        this.dados_convenio.desconto = 0
        this.dados_convenio.desconto_em_reais = null
      }
      this.verificarConvenios(true)
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  beforeMount () {
    this.pegarTodosItens()
    this.resetarCampos()
    this.verificarConvenios(false)
  },
  methods: {
    carregarImagem (event) {
      this.imagem_convenio = null
      let imagem = event.target.files[0]
      let reader = new FileReader()
      reader.onload = event => {
        var image = new Image()
        image.src = event.target.result
        var self = this
        image.onload = function (e) {
          var height = this.height
          var width = this.width
          if (height !== 400 || width !== 400) {
            const canvas = document.createElement('canvas')
            const maxWidth = 400
            const scaleSize = maxWidth / width
            canvas.width = maxWidth
            canvas.height = height * scaleSize
            if (canvas.height > 400) {
              const scaleSize = maxWidth / canvas.height
              canvas.height = maxWidth
              canvas.width = canvas.height * scaleSize
            }
            const ctx = canvas.getContext('2d')
            ctx.drawImage(e.target, 0, 0, canvas.width, canvas.height)
            const srcEncoded = ctx.canvas.toDataURL(e.target, 'image/jpeg')
            self.imagem_convenio = srcEncoded
            self.nome_imagem = imagem.name
            return true
          }
          self.imagem_convenio = event.target.result
          self.nome_imagem = imagem.name
          return true
        }
      }
      if (imagem) {
        reader.readAsDataURL(imagem)
      }
    },
    imagem_cropada (data) {
      this.imagem_convenio = data
      this.cropper = false
    },
    fechar_cropper () {
      this.cropper = false
      this.nome_imagem = null
      this.croppersrc = null
      this.imagem_convenio = null
    },
    continuar () {
      switch (this.step) {
        case 1:
          if (this.$refs.firstForm.validate()) {
            this.inserirConvenio()
          }
          break
        case 2:
          if (this.imagem_convenio) {
            this.concluirInsercao()
          } else {
            this.step = 1
            this.resetarCampos()
            this.fechar_cropper()
            this.$emit('concluir')
          }
          break
      }
    },
    voltar () {
      switch (this.step) {
        case 1:
          this.resetarCampos()
          this.$emit('fechar')
          break
        case 2:
          this.step = 1
          this.fechar_cropper()
          break
      }
    },
    resetarCampos () {
      this.dados_convenio = {
        convenio: {
          nome_convenio: null,
          url_imagem_codigo: null,
          privado: false,
          codigo: ''
        },
        desconto: null,
        desconto_em_reais: '0,00',
        qtd_codigos_limitado: false,
        qtd_codigos: null,
        item: 0
      }
    },
    concluirInsercao () {
      this.$store.dispatch('inserirBannerStorage', {
        prefixo: 'convenio',
        id: this.id_convenio,
        imagem: this.imagem_convenio
      }).then(downloadUrl => {
        this.dados_convenio.convenio.url_imagem_codigo = downloadUrl
        this.$store.dispatch('atualizarConvenio', {
          id: this.convenio_posto,
          data: {
            ...this.dados_convenio,
            percentual_desconto: this.dados_convenio.desconto,
            desconto_em_reais: this.tem_desconto_em_reais ? this.formatarValor(this.dados_convenio.desconto_em_reais) : null,
            cpfs_permitidos: [],
            url_imagem_codigo: downloadUrl
          }
        }).then(() => {
          this.step = 1
          this.resetarCampos()
          this.fechar_cropper()
          this.$emit('carregar')
          this.$emit('concluir')
        })
      })
    },
    inserirConvenio () {
      this.dados_convenio.convenio.codigo = this.dados_convenio.convenio.nome_convenio.toUpperCase()
      this.$store
        .dispatch('inserirConvenio', {
          ...this.dados_convenio,
          percentual_desconto: this.dados_convenio.desconto,
          desconto_em_reais: this.tem_desconto_em_reais ? this.formatarValor(this.dados_convenio.desconto_em_reais) : null,
          item: this.dados_convenio.item === 0 ? null : this.dados_convenio.item
        })
        .then((json) => {
          this.$emit('carregar')
          this.id_convenio = json.convenio.id
          this.convenio_posto = json.id
          this.step = 2
        })
    },
    pegarTodosItens () {
      const data = {
        method: 'GET',
        parameters: {
          posto: this.posto.cnpj
        }
      }
      data.parameters.categoria__referencia__icontains = 'combustivel'
      this.$store.dispatch('itens', data).then(json => {
        this.todos_itens = json
      })
    },
    verificarConvenios (mostrarError) {
      const data = {}
      if (this.tem_desconto_em_reais) {
        data.percentual_desconto__isnull = false
      } else {
        data.desconto_em_reais__isnull = false
      }
      this.$store.dispatch('verificarConvenios', data).then(json => {
        if (json.existe) {
          this.tem_desconto_em_reais = !this.tem_desconto_em_reais
          if (mostrarError) {
            this.showError('Você não pode cadastrar convênios com desconto em percentual e em reais simultaneamente.')
          }
        }
      })
    },
    showError (error) {
      this.snackbarerror.color = 'error'
      this.snackbarerror.errorText = error
      this.snackbarerror.active = true
    },
    formatarValor (valor) {
      return parseFloat(valor.replace('R$ ', '').replace('.', '').replace(',', '.'))
    }
  },
  directives: { money: VMoney }
}
</script>
